import {Link, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import Loading from "../../Components/Layout/Elements/Loading";
import {
    deleteCommunications,
    downloadAttachment,
    retrieveCommunicationDetail
} from "../../Api/Communications/CommunicationsFetch";
import {Alert, Badge, Button, Card, Col, Row} from "react-bootstrap";
import parse from 'html-react-parser';

import {formatDataIt} from "../../Utils/DateFormat";
import '../../assets/css/Communications/Communications.css';
import {LuFileDown, LuUserCircle} from "react-icons/lu";
import {ConfirmationModal} from "../../Components/Modals/ConfirmationModal";
import {RiDeleteBinLine} from "react-icons/ri";
import ModalCommunicationMembers from "../../Components/Modals/Communications/ModalCommunicationMembers";

const CommunicationDetail = (props) => {
    const {id} = useParams();
    const [communicationDetail, setCommunicationDetail] = useState([])
    const [errors, setErrors] = useState();
    const [message, setMessage] = useState()
    const [isLoading, setIsLoading] = useState()
    const [show, setShow] = useState();
    const [actionMessage, setActionMessage] = useState()
    const navigate = useNavigate()
    const [communicationMembers, setCommunicationMembers] = useState([])
    const [showMembers, setShowMembers] = useState(false)

    // const test= communicationDetail.content.toString()

    useEffect(() => {
        retrieveCommunicationDetail({id, setCommunicationDetail, setErrors, setIsLoading})

    }, [])
    useEffect(() => {
        if (communicationDetail) {
            setCommunicationMembers({
                sendOptions: communicationDetail.send_option,
                recipients: communicationDetail.recipients
            })
            console.log(communicationMembers)
        }
    }, [communicationDetail])

    useEffect(() => {
        console.log(communicationDetail)
    }, [communicationDetail])

    const handleDowloadFile = (e) => {
        console.log(e.currentTarget.getAttribute('data-id'))
        downloadAttachment({
            newsId: e.currentTarget.getAttribute('data-news-id'),
            id: e.currentTarget.getAttribute('data-id')
        })
    }

    const handleClose = () => {
        setShow(false)
    }
    const handleConfirm = (e) => {
        deleteCommunications({
            setIsLoading: props.setIsLoading,
            setErrors: props.setErrors,
            setMessage: props.setMessage,
            newsId: id,
            navigate: navigate

        })
        setShow(false)
    }

    return (
        <>
            {message && <Alert variant={'success'} onClick={() => {
                setMessage(null)
            }} dismissible> {message} </Alert>}
            {errors && typeof errors === 'string' && <Alert variant={'danger'} onClick={() => {
                setErrors(null)
            }} dismissible> {errors} </Alert>}

            <Row>
                <Col md={8} sm={12} className={'mt-2'}>
                    <Card className={'p-3 border-0 shadow h-100 text-start'}>
                        <h3 className={'py-3 fw-bold'}>{communicationDetail.title}</h3>
                        <div className="communication-content">{communicationDetail.content && parse(communicationDetail.content)}</div>


                    </Card>
                </Col>

                <Col md={4} sm={12} className={'text-start mt-2'}>
                    <Card className={'p-3 border-0 shadow h-100 '}>
                        <h4 className={'fw-bold text-second'}>Dettagli Comunicazione</h4>
                        <Row className={'mt-2'}><Col>
                            {communicationDetail.sender && (
                                <Col md={12} className={'mb-3'}>

                                    <div className={'d-flex align-items-center align-content-center gap-2 px-3 py-2 rounded-3'}
                                        >
                                        <LuUserCircle
                                        className={'fs-4 text-second flex-shrink-0'}/>
                                        <div>
                                            <span className={'fw-bold text-smaller d-block'} style={{lineHeight: 1}}>Inviato da</span>
                                            <span className={'fw-semibold text-truncate'}>{communicationDetail.sender}</span>
                                        </div>
                                    </div>
                                </Col>
                            )}
                            <Col md={12} className={'mb-2'}>
                                <p className={'d-inline fw-bold'}> Comunicazione inviata
                                    il: </p>
                                <b>{formatDataIt(new Date(communicationDetail.created_at))}</b>

                            </Col>
                            <Col md={12}
                                 className={`mb-2 ${communicationDetail.send_option !== 'All' && ' cursor-pointer'}`}
                                 onClick={() => {
                                     communicationDetail.send_option !== 'All' && setShowMembers(true)
                                 }}>
                                <p className={'d-inline fw-bold'}>Comunicazione inviata a:</p>&nbsp;&nbsp;
                                <Badge
                                    bg={communicationDetail.send_option === 'All' ? 'warning' : communicationDetail.send_option === 'Profile' ? 'primary' : 'info'}
                                    className={'col ms-1 d-inline text-end'}>{communicationDetail.send_option}
                                </Badge>
                                {communicationDetail.send_option !== 'All' &&
                                    <span className="text-smaller fw-bold ms-2 ">Vedi Lista</span>}
                            </Col>
                            <Col md={12} className={'mb-2'}>
                                <p className={'d-inline fw-bold'}>Percentuale
                                    accettati: {communicationDetail.acceptance_ratio}</p>
                            </Col>
                            {communicationDetail.attachments && (
                                <>
                                    <p className={'fw-bold mb-1 mt-2'}>Allegati: </p>
                                    {communicationDetail.attachments.map(i => {
                                        return (
                                            <span className={'d-block mb-1'}><Link
                                                className={'text-decoration-none text-second'} key={i.id}
                                                data-news-id={i.news_id} data-id={i.id} onClick={handleDowloadFile}>
                                                <LuFileDown className={'fs-4 '}/> {i.original_filename}
                                            </Link>
                                            </span>
                                        )
                                    })}
                                </>

                            )}
                        </Col>
                            <Col md={12} className={'text-center mt-3'}>
                                <Button className={'btn bg-danger border-0 w-100'} onClick={() => {
                                    setShow(true)
                                    setActionMessage(parse('Sei sicuro di voler eliminare la comunicazione?'))

                                }}>
                                    <RiDeleteBinLine className={'fs-5 text-white me-2'}/> Elimina comunicazione
                                </Button>
                            </Col>

                        </Row>


                    </Card>
                </Col>
                <ModalCommunicationMembers show={showMembers} handleClose={() => {
                    setShowMembers(false)
                }} communicationMembers={communicationMembers} setCommunicationMembers={setCommunicationMembers}
                                           setShowMembers={setShowMembers}/>
            </Row>

            {isLoading && <Loading/>}
            <ConfirmationModal show={show} handleClose={handleClose}
                               handleConfirm={handleConfirm} actionMessage={actionMessage}></ConfirmationModal>
        </>

    )
}

export default CommunicationDetail